// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".home__header {\n  margin-top: 2.625rem;\n}\n", "",{"version":3,"sources":["/home/jenkins/agent/workspace/helpcenter-release/client/src/styles/pages/home.less","home.less"],"names":[],"mappings":"AAAA;EACE,oBAAA;ACCF","file":"home.less","sourcesContent":[".home__header {\n  margin-top: 2.625rem;\n}\n",".home__header {\n  margin-top: 2.625rem;\n}\n"]}]);
// Exports
module.exports = exports;
